<template>
  <v-container fluid align="center" justify="center" class="py-2">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card elevation="0" class="bs-main-card tw-mt-2 md:tw-mt-4">
          <div class="bs-header">
            <div class="bs-badge">
              <v-icon color="white">mdi-chat-processing</v-icon>
            </div>
            <h2 class="bs-title">Bids Submitted</h2>
          </div>
          <div v-if="isBookings || search">
            <div class="tw-flex tw-justify-end">
              <div class="tw-w-full sm:tw-w-1/3 md:tw-w-1/4 tw-pb-3 md:tw-pb-5">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </div>
            </div>
            <v-divider class="mb-3" />
            <v-data-table
              :headers="headers"
              :items="bookings"
              :loading="loadingTable"
              class="elevation-0 bs-table"
              :search.sync="search"
              :page.sync="pagination.pageNumber"
              :items-per-page.sync="pagination.perPage"
              :server-items-length="pagination.totalItems"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :footer-props="{
                itemsPerPageOptions: [10, 20, 30, 40, 50],
              }"
            >
              <template v-slot:[`item.accidentCategory`]="{ item }">
                <v-chip
                  v-if="item.status === 'EXT_ASSESSOR_ASSIGNED'"
                  color="warning"
                  small
                  >{{ item.accidentCategory }}</v-chip
                >
                <v-chip
                  v-else-if="item.status === 'ASSIGNED_TO_CLUSTER'"
                  color="success"
                  small
                >
                  Bid Template Sent</v-chip
                >
                <v-chip
                  v-else-if="item.status === 'BIDDING_TEMPLATE_CREATED'"
                  color="primary"
                  small
                >
                  Bid Template created</v-chip
                >
                <v-chip v-else color="success" small> {{ item.status }}</v-chip>
              </template>
              <template v-slot:[`item.biddingTemplate.make`]="{ item }">
                <p>
                  {{ item.biddingTemplate.make }}
                  {{ item.biddingTemplate.model }}
                </p>
              </template>
              <template v-slot:[`item.createdAt`]="{ item }">
                <span>{{ item.createdAt | formatToHuman }}</span>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <div class="tw-flex tw-flex-row">
                  <router-link
                    :to="{ name: 'BidDetails', params: { bookingId: item.id } }"
                    :key="item.action"
                    ><v-icon color="primary" small>mdi-eye</v-icon>
                    View</router-link
                  >
                  <v-btn
                    v-if="item.status === 'EXT_ASSESSOR_ASSIGNED'"
                    class="tw-ml-2"
                    color="warning"
                    small
                    :to="{
                      name: 'BidFormPreparation',
                      params: { bookingId: item.id },
                    }"
                    >Create Report</v-btn
                  >
                </div>
              </template>
            </v-data-table>
          </div>
          <div
            v-else
            class="tw-py-4 md:tw-py-14 tw-flex tw-items-center tw-justify-center tw-flex-col"
          >
            <img
              :src="require('@/assets/img/assesment-center/no-car.png')"
              class="tw-h-16 md:tw-h-28"
              alt="no car"
            />
            <p class="tw-w-full md:tw-w-1/3 tw-text-xs tw-p-3 tw-text-justify">
              There’s no Bids Submitted here, please head to the
              <span class="c-blue-text tw-font-bold"
                >next module in the action panel</span
              >
            </p>
            <v-btn
              :to="{ name: 'AssessmentCenter' }"
              class="tw-w-full md:tw-w-1/3"
              color="warning"
              >Go To Action Panel</v-btn
            >
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formatToHuman } from '@/utils/time'
import bookingsMixin from '@/mixins/bookingsMixin'
export default {
  name: 'BidSubmitted',
  mixins: [bookingsMixin],
  data() {
    return {
      loadingTable: true,
      headers: [
        { text: 'No.', value: 'id' },
        { text: 'Customer', value: 'clientInfo.name', sortable: false },
        { text: 'Make/Model', value: 'biddingTemplate.make', sortable: false },
        { text: 'Reg. No.', value: 'vehicleInfo.registrationNumber' },
        { text: 'Date', value: 'createdAt' },
        { text: 'Phone No.', value: 'clientInfo.phoneNumber', sortable: false },
        { text: 'Status', value: 'accidentCategory' },
        { text: 'Action', value: 'action', sortable: false },
      ],
      bookings: [],
      fetchBookingsUrl:
        '/motor-assessment/api/booking?bookingRequestType=BOOKING_BY_STATUS&bookingStatus=ASSIGNED_TO_CLUSTER',
    }
  },
  computed: {
    isBookings() {
      return this.bookings.length > 0 || this.loadingTable
    },
  },
  mounted() {
    this.fetchBookings()
    this.sortBy = [false, false, false, false]
  },
  filters: {
    formatToHuman,
  },
}
</script>

<style scoped>
.bs-main-card {
  border-radius: 18px;
  border: 1px solid #e8edf5;
  background: #ffffff;
  padding: 18px 20px 20px;
}
.bs-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.bs-badge {
  flex: 0 0 auto;
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #034ea2 0%, #0a63c4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(3, 78, 162, 0.25);
}
.bs-title {
  font-size: 20px;
  font-weight: 800;
  color: #0f2a55;
  margin: 0;
}
.bs-table {
  border-radius: 12px;
  border: 1px solid #eef2f8;
  overflow: hidden;
}
</style>
